import { lazy,Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const GoogleAdsRegister = lazy(() => import('../pages/ga-register'))

export const googleAdsRegisterRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/ga-register',
  component: GoogleAdsRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
